import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as landingblockActions from '../actions/landing-pages.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { LandingPagesService } from '../../services';
import { Go } from 'src/app/store';

@Injectable()
export class LandingPagesEffects {
  private actions$ = inject(Actions);
  private PageService = inject(LandingPagesService);


  LoadBugs$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(landingblockActions.LoadLandingPages),
      switchMap(() =>
        this.PageService.getPages().pipe(
          map(landingPages => landingblockActions.LoadLandingPagesSuccess({ landingPages })),
          catchError(error => of(landingblockActions.LoadLandingPagesFail({ error })))
        )
      )
    );
  });

  LoadBySlug$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(landingblockActions.LoadLandingPageBySlug),
      switchMap(({ slug }) =>
        this.PageService.getPageBySlug(slug).pipe(
          map(page => landingblockActions.LoadLandingPageBySlugSuccess({ page })),
          catchError(error => of(landingblockActions.LoadLandingPageBySlugFail({ error, slug })))
        )
      )
    );
  });

  LoadById$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(landingblockActions.LoadLandingPageById),
      switchMap(({ id }) =>
        this.PageService.getPageById(id).pipe(
          map(page => landingblockActions.LoadLandingPageByIdSuccess({ page })),
          catchError(error => of(landingblockActions.LoadLandingPageByIdFail({ error, id: id.toString() })))
        )
      )
    );
  });


  LoadBySlugFail$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(landingblockActions.LoadLandingPageBySlugFail),
        map(({ error }) => {
          return Go({ path: ['/' + error?.status ? error.status : '404'], extras: { skipLocationChange: true } });
        })
      );
    },
    { functional: true }
  );

  LoadByIdFail$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(landingblockActions.LoadLandingPageByIdFail),
        map(({ error }) => {
          return Go({ path: ['/' + error?.status ? error.status : '404'], extras: { skipLocationChange: true } });
        })
      );
    },
  );
}
